import React from "react";
import {
  BarChart,
  ResponsiveContainer,
  Bar,
  YAxis,
  XAxis,
  CartesianGrid,
} from "recharts";
import { useIsXXLMediaQuery } from "@app/hooks";
import { ChartData } from "../../types";
import { CHART_SETTINGS } from "./constants";

type Props = {
  series: ChartData[];
};

export const Chart: React.FC<Props> = ({ series }) => {
  const isXXLScreen = useIsXXLMediaQuery();

  return (
    <ResponsiveContainer
      height={
        isXXLScreen
          ? CHART_SETTINGS.largeScreen.height
          : CHART_SETTINGS.mobile.height
      }
      width="100%"
    >
      <BarChart
        width={500}
        height={
          isXXLScreen
            ? CHART_SETTINGS.largeScreen.height
            : CHART_SETTINGS.mobile.height
        }
        data={series}
      >
        <CartesianGrid
          strokeDasharray="3 3"
          vertical={false}
          stroke="#333333"
        />
        <YAxis
          orientation="left"
          axisLine={false}
          width={40}
          type="number"
          includeHidden
          tickCount={11}
          tickFormatter={(tick) =>
            `${Math.round(Number(tick * 100)).toString()}%`
          }
          stroke="#999999"
          dataKey={"percentage"}
          tickLine={false}
          scale={"linear"}
        />
        <XAxis
          dataKey={"volatility"}
          interval={0}
          angle={-45}
          tickLine={false}
          tickMargin={
            isXXLScreen
              ? CHART_SETTINGS.largeScreen.xAxis.tickMargin
              : CHART_SETTINGS.mobile.xAxis.tickMargin
          }
          height={
            isXXLScreen
              ? CHART_SETTINGS.largeScreen.xAxis.height
              : CHART_SETTINGS.mobile.xAxis.height
          }
          tick={{
            fill: "#999999",
            fontSize: isXXLScreen
              ? CHART_SETTINGS.largeScreen.xAxis.fontSize
              : CHART_SETTINGS.mobile.xAxis.fontSize,
          }}
          stroke="#ffffff"
        />
        <Bar dataKey="percentage" fill="#2B4387" />
      </BarChart>
    </ResponsiveContainer>
  );
};
